<div class="financial-introduction row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 offset-md-2 offset-lg-2 offset-xl-2">
        <div class="img-container">
            <img id="financialIntroImg" alt="Imagen financial-introduction" src="assets/images/financial-introduction.svg"/>
        </div>
        <h2 class="name">{{ this.documentInfo.firstname }},</h2>
        <p class="description" [innerHtml]="copyService.copies.financial_introduction_description"></p>
    </div>
</div>
<app-controls id="financialIntroBtns" [hasPrevious]="false" [nextLabel]="copyService.copies.financial_introduction_button" (next)="next()"></app-controls>